import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { regionFromKmsKeyArn } from './region_from_kms_key_arn';
import { EncryptedDataKey, needs } from '@aws-crypto/material-management';
export var KMS_PROVIDER_ID = 'aws-kms';
export function generateDataKey(_x, _x2, _x3, _x4, _x5) {
  return _generateDataKey.apply(this, arguments);
}

function _generateDataKey() {
  _generateDataKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(clientProvider, NumberOfBytes, KeyId, EncryptionContext, GrantTokens) {
    var region, client, v2vsV3Response, v2vsV3Promise, dataKey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            region = regionFromKmsKeyArn(KeyId);
            client = clientProvider(region);
            /* Check for early return (Postcondition): clientProvider did not return a client for generateDataKey. */

            if (client) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", false);

          case 4:
            v2vsV3Response = client.generateDataKey({
              KeyId: KeyId,
              GrantTokens: GrantTokens,
              NumberOfBytes: NumberOfBytes,
              EncryptionContext: EncryptionContext
            });
            v2vsV3Promise = 'promise' in v2vsV3Response ? v2vsV3Response.promise() : v2vsV3Response;
            _context.next = 8;
            return v2vsV3Promise;

          case 8:
            dataKey = _context.sent;
            return _context.abrupt("return", safeGenerateDataKey(dataKey));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _generateDataKey.apply(this, arguments);
}

export function encrypt(_x6, _x7, _x8, _x9, _x10) {
  return _encrypt.apply(this, arguments);
}

function _encrypt() {
  _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(clientProvider, Plaintext, KeyId, EncryptionContext, GrantTokens) {
    var region, client, v2vsV3Response, v2vsV3Promise, kmsEDK;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            region = regionFromKmsKeyArn(KeyId);
            client = clientProvider(region);
            /* Check for early return (Postcondition): clientProvider did not return a client for encrypt. */

            if (client) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", false);

          case 4:
            v2vsV3Response = client.encrypt({
              KeyId: KeyId,
              Plaintext: Plaintext,
              EncryptionContext: EncryptionContext,
              GrantTokens: GrantTokens
            });
            v2vsV3Promise = 'promise' in v2vsV3Response ? v2vsV3Response.promise() : v2vsV3Response;
            _context2.next = 8;
            return v2vsV3Promise;

          case 8:
            kmsEDK = _context2.sent;
            return _context2.abrupt("return", safeEncryptOutput(kmsEDK));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _encrypt.apply(this, arguments);
}

export function decrypt(_x11, _x12, _x13, _x14) {
  return _decrypt.apply(this, arguments);
}

function _decrypt() {
  _decrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(clientProvider, _ref, EncryptionContext, GrantTokens) {
    var providerId, providerInfo, encryptedDataKey, region, client, v2vsV3Response, v2vsV3Promise, dataKey;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            providerId = _ref.providerId, providerInfo = _ref.providerInfo, encryptedDataKey = _ref.encryptedDataKey;

            /* Precondition:  The EDK must be a KMS edk. */
            needs(providerId === KMS_PROVIDER_ID, 'Unsupported providerId');
            region = regionFromKmsKeyArn(providerInfo);
            client = clientProvider(region);
            /* Check for early return (Postcondition): clientProvider did not return a client for decrypt. */

            if (client) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", false);

          case 6:
            /* The AWS KMS KeyId *must* be set. */
            v2vsV3Response = client.decrypt({
              KeyId: providerInfo,
              CiphertextBlob: encryptedDataKey,
              EncryptionContext: EncryptionContext,
              GrantTokens: GrantTokens
            });
            v2vsV3Promise = 'promise' in v2vsV3Response ? v2vsV3Response.promise() : v2vsV3Response;
            _context3.next = 10;
            return v2vsV3Promise;

          case 10:
            dataKey = _context3.sent;
            return _context3.abrupt("return", safeDecryptOutput(dataKey));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _decrypt.apply(this, arguments);
}

export function kmsResponseToEncryptedDataKey(_ref2) {
  var providerInfo = _ref2.KeyId,
      encryptedDataKey = _ref2.CiphertextBlob;
  return new EncryptedDataKey({
    providerId: KMS_PROVIDER_ID,
    providerInfo: providerInfo,
    encryptedDataKey: encryptedDataKey
  });
}

function safeGenerateDataKey(dataKey) {
  /* Postcondition: KMS must return serializable generate data key. */
  needs(typeof dataKey.KeyId === 'string' && dataKey.Plaintext instanceof Uint8Array && dataKey.CiphertextBlob instanceof Uint8Array, 'Malformed KMS response.');
  return safePlaintext(dataKey);
}

function safeEncryptOutput(dataKey) {
  /* Postcondition: KMS must return serializable encrypted data key. */
  needs(typeof dataKey.KeyId === 'string' && dataKey.CiphertextBlob instanceof Uint8Array, 'Malformed KMS response.');
  return dataKey;
}

function safeDecryptOutput(dataKey) {
  /* Postcondition: KMS must return usable decrypted key. */
  needs(typeof dataKey.KeyId === 'string' && dataKey.Plaintext instanceof Uint8Array, 'Malformed KMS response.');
  return safePlaintext(dataKey);
}

function safePlaintext(dataKey) {
  /* The KMS Client *may* return a Buffer that is not isolated.
   * i.e. the byteOffset !== 0.
   * This means that the unencrypted data key is possibly accessible to someone else.
   * If this is the node shared Buffer, then other code within this process _could_ find this secret.
   * Copy Plaintext to an isolated ArrayBuffer and zero the Plaintext.
   * This means that this function will *always* zero out the value returned to it from the KMS client.
   * While this is safe to do here, copying this code somewhere else may produce unexpected results.
   */
  var Plaintext = dataKey.Plaintext;
  dataKey.Plaintext = new Uint8Array(Plaintext);
  Plaintext.fill(0);
  return dataKey;
}